export default "__VITE_PUBLIC_ASSET__4223d48e__"